import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import ScheduleHeaderDSL from './schedule_DSL/ScheduleHeaderDSL'
import ScheduleDatesDSL from './schedule_DSL/ScheduleDatesDSL'
import groupBy from 'lodash/groupBy'
import get from 'lodash/get'
import map from 'lodash/map'
import moment from 'moment'
import store from 'store2'
import API from '../../api'
import { FormattedMessage } from 'react-intl'
import PlaceholderTrips from '../search/PlaceholderTrips'
import Loader from '../helpers/Loader'
import messages from './messages'
import {
  setDepartureDate,
  setScheduleType,
} from '../../actions/dive-operator-actions'

import styles from './schedule_DSL/scheduleTabelDSL.module.scss'
import cx from 'classnames'
import { setScheduleState } from '../../actions/dsl-dive-center-actions'

function Schedule({
  diveCenterId,
  setDepartureDate,
  setScheduleType,
  scheduleType,
  setScheduleState,
  scheduleIsShown,
  isBookableActivitiesExists,
}) {
  const selectedDate = store('date')
  const date = get(selectedDate, '[0]')
  const [firstLoading, setFirstLoading] = useState(true)
  const [isLoading, setLoading] = useState(true)
  const [items, setItems] = useState([])
  const [filters, setFilters] = useState({
    page: 1,
    date: date || undefined,
    page_size: 10,
  })
  const [nextPageAvailable, setNextPageAvailable] = useState(false)
  useEffect(() => {
    setLoading(true)
    getItems()
  }, [scheduleType, filters])

  useEffect(() => {
    setScheduleState(isBookableActivitiesExists)
  }, [])

  const getItems = () => {
    API(
      `/api/adventure/v1/dive-centers/${diveCenterId}/${scheduleType}/`,
      false,
      false,
      true
    )
      .get(filters)
      .then((data) => {
        if(!data.ok) {
          setItems([])
        }

        const groupedItems = map(groupBy(data.results, 'availableDate'))

        setNextPageAvailable(!!data.next)
        if(filters.page > 1) {
          setItems([...items, ...groupedItems])
        } else {
          setItems(groupedItems)
        }
      })
      .finally(() => {
        setLoading(false)
        setFirstLoading(false)
      })
  }

  const onTypeChange = (type) => {
    setFilters({
      ...filters,
      page: 1,
    })
    setScheduleType(type)
  }

  const onDateChange = (date) => {
    const dateFrom = date && date.dateFrom ? date.dateFrom : undefined
    setFilters({
      page: 1,
      date: dateFrom,
      page_size: 10,
    })
    if(dateFrom) {
      store.set('date', [dateFrom, moment(dateFrom).add(7, 'days')])
    }
    setDepartureDate(dateFrom)
  }

  const loadMore = () => {
    setFilters({
      ...filters,
      page: filters.page + 1,
    })
  }

  if(firstLoading) {
    return (
      <div className='wrapper'>
        <PlaceholderTrips />
      </div>
    )
  }

  if(!scheduleIsShown) {
    return null
  }

  return (
    <div className='wrapper trip-wrapper'>
      <div className={styles.scheduleTop}>
        <h3 className='do-section-title'>
          <FormattedMessage id='schedule' defaultMessage='Schedule' />
        </h3>
      </div>
      <div
        className={cx(styles.scheduleTable, { 'react-app-loading': isLoading })}
      >
        <Loader />
        <ScheduleHeaderDSL
          selectedType={scheduleType}
          onTypeChange={onTypeChange}
          onDateChange={onDateChange}
          dateFrom={filters.date}
        />
        {!items.length && (
          <div className={styles.noResults}>
            <FormattedMessage {...messages[scheduleType]} />
          </div>
        )}

        {items.map((data, index) => {
          const offset = get(items, `[${index - 1}].length`, 0)
          return (
            <ScheduleDatesDSL
              key={index}
              items={data}
              offset={offset}
              date={data[0].availableDate}
            />
          )
        })}
        {nextPageAvailable && (
          <div className='text-center'>
            <button className='dsl-btn-blue-invert' onClick={loadMore}>
              <FormattedMessage
                id='load_more'
                defaultMessage='Load more results'
              />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default connect(
  ({ scheduleType, scheduleIsShown }) => ({
    scheduleType,
    scheduleIsShown,
  }),
  { setDepartureDate, setScheduleType, setScheduleState }
)(Schedule)
